import type { IconName } from '@/components/dynamic-heroicon';

// Example:
// academic-cap -> AcademicCapIcon
export function convertStringToIconName(iconName: string) {
  if (!iconName) {
    return 'AcademicCapIcon' as IconName;
  }
  const words: string[] = iconName.split('-');

  const capitalizedWords = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');

  const result = `${capitalizedWords}Icon`;

  return result as IconName;
}
